enum CustomConfigs {
  DisableGTM = 'vdp-disable-gtm',
  EnableDebug = 'merch-enable-debug',
  DisableLazyLoad = 'vdp-disable-lazy-load',
  DisableSpinner = 'vdp-disable-spinner',
  enableGeicoDiscount = 'enable-geico-discount',
  enableNccConditionalPromo = 'enable-ncc-conditional-promo',
  enableRootDiscount = 'enable-root-discount',
  EnableMfeDebug = 'merch-enable-mfe-debug',
  FeatureBranch = 'feature-branch',
  ForceServerError = 'force-server-error',
  MockVehicle = 'vdp-mock-vehicle',
  PriceDrop = 'show-price-drop-banner',
  RemoveFooter = 'merch-remove-footer',
  RemoveHeader = 'merch-remove-header',
  shouldShowWSYS = 'should-show-wsys',
  shouldUseTitleCasing = 'should-use-title-casing',
  showShaqvanaVideosSection = 'show-shaqvana-videos-section',
  useCatalogOEMData = 'use-catalog-oem-data',
  useVaultWhyBuy = 'use-vault-why-buy',
  withModalOpen = 'wmo'
}

export default CustomConfigs;
